import React from "react";
import { PropTypes } from "prop-types";

import { TextField as MuiTextField } from "@mui/material";
import { inputStyles } from "../StyledElements";
import { defaultIfEmpty } from "../../shared/utils/utils";

export default function NumberInput({
  value,
  disabled = false,
  onChange,
  inputRef,
  error = false,
  name,
  autoComplete,
  label = null,
  placeholder = "",
  ...props
}) {
  // const _props = (autoComplete === null) ? {} : { autoComplete: autoComplete || "off" }
  return (
    <MuiTextField
      value={defaultIfEmpty(value)}
      size="small"
      type="number"
      disabled={disabled}
      label={label}
      name={name}
      sx={{ ...inputStyles.inputField, ...((props || {}).sx || {}) }}
      // inputProps={{sx: inputStyles.newInput}}
      onChange={(e) =>
        onChange(isNaN(e.target.valueAsNumber) ? null : e.target.valueAsNumber)
      }
      error={error}
      // focused
      placeholder={placeholder}
      inputRef={inputRef}
      variant={"standard"}
      autoComplete="off"
      // {..._props}
      {...props}
    />
  );
}

NumberInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  error: PropTypes.bool,
  name: PropTypes.string,
  autoComplete: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
};
